import { showDialog } from '@wwe-portal/ui/components/dialog';
import { useTranslations } from 'next-intl';
import { useClaimSoloEventMilestoneReward } from '@wwe-portal/web/providers/queries/rbe.mutation';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { LoginDialogPortable } from '../auth/login-dialog';
import { useProcessingDialog } from '@wwe-portal/web/hooks/payment/processing-dialog';
import { VERIFY_DURATION_MS } from '@wwe-portal/web/utils/constants/offer';
import { wait } from '../../../../../packages/ui/lib/timer';

export const useClaimReward = ({
  eventId,
  milestoneId,
}: {
  eventId: number;
  milestoneId: string;
}) => {
  const t = useTranslations();
  const { showProcess, showSuccess } = useProcessingDialog({
    progressData: {
      title: t('reward_title_load'),
      description: t('reward_description_load'),
      duration: VERIFY_DURATION_MS,
    },
    successData: {
      title: t('reward_claimed'),
      description: t('reward_description_successful'),
    },
  });
  const { mutate: claimMilestoneReward, isPending } =
    useClaimSoloEventMilestoneReward();
  const isAuthenticated = useIsAuthenticated();

  const claim = () => {
    if (!isAuthenticated) {
      showDialog(LoginDialogPortable);
      return;
    }
    claimMilestoneReward(
      {
        milestoneId,
        eventId,
      },
      {
        onSuccess: async () => {
          showProcess();
          await wait(VERIFY_DURATION_MS);
          showSuccess();
        },
      }
    );
  };

  return {
    isPending,
    claim,
  };
};
